<template>
  <v-layout row wrap>
    <v-flex xs7>
      <v-layout justify-center row wrap class="py-2">
        <v-flex text-xs-center>
          <h1
            align-center
            row
            :class="(invoice.amount >= 0 ? 'ctcGreen' : 'ctcRed') + '--text'"
          >
            {{ inCurrency(selectedCurrencyCode(), invoice.amount) }}
          </h1>
          <p align-center class="font-weight-medium font-italic body-2">
            {{ invoice.is_credit_note ? "Credit Note " : "Invoice " }}Amount
          </p>
        </v-flex>
      </v-layout>

      <!-- Invoice Date -->
      <v-layout style="padding-top: 14px; padding-bottom: 14px;" align-center>
        <v-flex xs4 offset-xs1>
          <span style="color: #757575;">
            <v-icon small class="pr-1" color="#757575">event</v-icon
            >Reconciliation Status:
          </span>
        </v-flex>
        <v-flex xs6>
          <v-chip>
            <v-icon
              size="14"
              class="pr-1"
              :color="statusColor(statusLabel(invoice.reconciliation_status))"
              >{{
                statusIcon(statusLabel(invoice.reconciliation_status))
              }}</v-icon
            >
              <template
                  v-if="statusLabel(invoice.reconciliation_status) == 'Remaining payment'"
                >
                  {{statusLabel(invoice.reconciliation_status) + ": " }}
                  <strong class="pl-1">{{inCurrencyFromId(invoice.currency_id,invoice.amount - invoice.reconciliated_amount)}}</strong>
                </template>
                <template v-else>{{statusLabel(invoice.reconciliation_status)}}</template>
          </v-chip>
        </v-flex>
      </v-layout>
      <v-flex class="px-5">
        <v-divider />
      </v-flex>

      <!-- Invoice Date -->
      <v-layout style="padding-top: 14px; padding-bottom: 14px;" align-center>
        <v-flex xs4 offset-xs1>
          <span style="color: #757575;">
            <v-icon small class="pr-1" color="#757575">event</v-icon>
            {{ invoice.is_credit_note ? "Credit Note " : "Invoice " }}Date:
          </span>
        </v-flex>
        <v-flex xs6>{{ invoice.invoice_date }}</v-flex>
      </v-layout>
      <v-flex class="px-5">
        <v-divider />
      </v-flex>

      <!-- Subsidiary -->
      <v-layout style="padding-top: 14px; padding-bottom: 14px;" align-center>
        <v-flex xs4 offset-xs1>
          <span style="color: #757575;">
            <v-icon small class="pr-1" color="#757575">store</v-icon>Subsidiary:
          </span>
        </v-flex>
        <v-flex xs6>{{
          getNameById(invoice.subsidiary_company_id, "companies")
        }}</v-flex>
      </v-layout>
      <v-flex class="px-5">
        <v-divider />
      </v-flex>

      <!-- Company -->
      <v-layout style="padding-top: 14px; padding-bottom: 14px;" align-center>
        <v-flex xs4 offset-xs1>
          <span style="color: #757575;">
            <v-icon small class="pr-1" color="#757575">storefront</v-icon>
            {{ companyLabel }}:
          </span>
        </v-flex>
        <v-flex xs6>{{
          invoice.company_id
            ? getNameById(invoice.company_id, "companies")
            : invoice.company_name
        }}</v-flex>
      </v-layout>
      <v-flex class="px-5">
        <v-divider />
      </v-flex>

      <!-- Reference -->
      <v-layout style="padding-top: 14px; padding-bottom: 14px;" align-center>
        <v-flex xs4 offset-xs1>
          <span style="color: #757575;">
            <v-icon small class="pr-1" color="#757575"
              >mdi-format-quote-close</v-icon
            >Reference:
          </span>
        </v-flex>
        <v-flex xs6>{{ invoice.designation }}</v-flex>
      </v-layout>
      <v-flex class="px-5">
        <v-divider />
      </v-flex>

      <!-- Expected Payment Date -->
      <v-layout style="padding-top: 14px; padding-bottom: 14px;" align-center>
        <v-flex xs4 offset-xs1>
          <span style="color: #757575;">
            <v-icon small class="pr-1" color="#757575"
              >mdi-calendar-check</v-icon
            >Expected Payment Date:
          </span>
        </v-flex>
        <v-flex xs6>{{ invoice.expected_payment_date }}</v-flex>
      </v-layout>
      <v-flex class="px-5">
        <v-divider />
      </v-flex>

      <!-- Invoice Number -->
      <v-layout style="padding-top: 14px; padding-bottom: 14px;" align-center>
        <v-flex xs4 offset-xs1>
          <span style="color: #757575;">
            <v-icon small class="pr-1" color="#757575">receipt</v-icon>
            {{ invoice.is_credit_note ? "Credit Note " : "Invoice " }}Number:
          </span>
        </v-flex>
        <v-flex xs6>{{ invoice.invoice_number }}</v-flex>
      </v-layout>
      <v-flex class="px-5">
        <v-divider />
      </v-flex>
      <v-layout style="padding-top: 14px; padding-bottom: 14px;" align-center>
        <v-flex xs4 offset-xs1>
          <span style="color: #757575;">
            <v-icon small class="pr-1" color="#757575">attachment</v-icon
            >Document URL:
          </span>
        </v-flex>
        <v-flex xs6>
          <v-icon
            color="blue"
            size="12"
            class="pr-1"
            style="position: relative; top: -1px;"
            v-if="invoice.document_url"
            >mdi-open-in-new</v-icon
          >
          <a target="_blank" :href="s3bucket + '/' + invoice.document_url">{{
            truncate(invoice.document_url)
          }}</a>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex xs5>
      <v-layout row wrap class="text-xs-center" justify-center>
        <v-flex xs11 class="text-xs-center">
          <filePreviewer
            :hideToolbar="true"
            height="520"
            :filename="invoice.document_url"
            :url="s3bucket + '/' + invoice.document_url"
            v-if="invoice.document_url"
          />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import currency from "../../../mixins/currency";
import filePreviewer from "../../../components/shared/filePreviewer";
import date from "../../../mixins/date";
import accountingStatus from "../../../mixins/accountingStatus.js";
export default {
  name: "invoiceShow",
  components: {
    filePreviewer,
  },
  mixins: [currency, date, accountingStatus],
  props: {
    invoice: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      s3bucket: process.env.VUE_APP_S3_BUCKET_URL,
    };
  },
  computed: {
    ...mapGetters("commonStore", [
      "subsidiaries",
      "getNameById",
      "serviceSuppliers",
      "productSuppliers",
      "customers",
      "notSubsidiaries",
      "currencies",
      "accountTypes",
    ]),
    selectedSubsidiary() {
      var currentSubsidiaryId = this.invoice.subsidiary_company_id;

      return this.subsidiaries.find((e) => e.id === currentSubsidiaryId);
    },
    invoiceFileName() {
      return this.editedInvoice.designation
        .replace(/[\/\.]/g, "-")
        .replace(/\s/g, "")
        .replace(/[^a-z0-9_-]/gi, "")
        .toLowerCase();
    },
    companyLabel() {
      return this.invoice.operation_type == "credit" ? "Customer" : "Supplier";
    },
    supplierCompanies() {
      /* buying / selling product invoice */
      if (this.invoice.expedition_id) return this.productSuppliers;

      /* score_cost invoice */
      if (this.invoice.supplier_type_id)
        return this.serviceSuppliers(this.invoice.supplier_type_id);
      else return this.notSubsidiaries;
    },
    selectedCompanies() {
      if (this.invoice.is_credit_note) {
        if (this.invoice.operation_type === "credit")
          return this.supplierCompanies;
        else return this.customers;
      } else {
        if (this.invoice.operation_type === "credit") return this.customers;
        else return this.supplierCompanies;
      }
    },
    selectedSubsidiary() {
      var currentSubsidiaryId = this.invoice.subsidiary_company_id;

      return this.subsidiaries.find((e) => e.id === currentSubsidiaryId);
    },
    subsidiaryCurrencies() {
      var currentSubsidiary = this.selectedSubsidiary;
      if (!currentSubsidiary) return [];
      return currentSubsidiary.subsidiary.bank_informations.map(
        (e) => e.currency
      );
    },
  },
  methods: {
    truncate(input) {
      if (!input) return "";
      if (input.length > 30) return input.substring(0, 30) + "...";
      else return input;
    },
    toggleFilePreview() {
      this.showFilePreview = !this.showFilePreview;
    },
    selectedCurrencyCode() {
      return this.currencies.find((e) => e.id === this.invoice.currency_id)
        .code;
    },
  },
  created() {},
  watch: {},
};
</script>
